export default __webpack_public_path__ + "static/media/app-store.f34e9a28.svg";